<template>
    <v-list-item two-line>
        <v-list-item-content>
            <v-list-item-title
                v-text="`
                    ${participantActivity.participant.firstname}
                    ${participantActivity.participant.lastname}
                    ${role === 'Sysadmin' ? `(${participantActivity.participant.id})` : ''}
                `"
            />
            <v-list-item-subtitle v-if="!hideQuestTitle" v-text="participantActivity.activity.name" />
        </v-list-item-content>

        <v-list-item-action tile>
            <v-btn icon @click="dialog = true">
                <v-icon color="primary">fas fa-angle-right</v-icon>
            </v-btn>
        </v-list-item-action>

        <contact-details
            v-if="dialog"
            v-model="dialog"
            :contact-id="participantActivity.participant.id"
            :hide-remove-contact-button="hideRemoveContactButton"
        />
    </v-list-item>
</template>

<script>
import ContactDetails from './ContactDetails';
import {mapState} from 'vuex';

export default {
    components: {
        ContactDetails,
    },
    props: {
        participantActivity: {
            type: Object,
        },
        hideQuestTitle: Boolean,
        hideRemoveContactButton: Boolean,
    },
    data() {
        return {
            dialog: false,
        };
    },
    computed: {
        ...mapState('user', ['role']),
    },
};
</script>
